import * as React from 'react';

import { enumCurrencyCode } from '@rematter/frontend-lib-api-client';
import { TouchNumberField } from '@rematter/ui-web';

import { FreightChargeFieldProps } from '../_types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { toMoney } from '~/modules/trade/utils/money';
import { useUIPreferences } from '~/shared/hooks';

//
// ⚛️ ⚛️ ⚛️ CHARGEBACK FIELD ⚛️ ⚛️ ⚛️
//
export const ChargebackField: React.FC<FreightChargeFieldProps> = ({
  freightCharge,
  disabled = false,
  onUpdateFreightCharge,
}) => {
  // Translations
  const t = useTranslations();

  // Data hooks
  const { touchModeEnabled } = useUIPreferences();

  // Callbacks
  const handleChange = React.useCallback(
    (value: number) => {
      const currencyCode =
        freightCharge.freightCost?.currencyCode ?? enumCurrencyCode.USD;

      onUpdateFreightCharge(freightCharge.id, {
        freightCost: toMoney({
          amount: value,
          currencyCode,
        }),
      });
    },
    [freightCharge.id, freightCharge.freightCost, onUpdateFreightCharge],
  );

  return (
    <TouchNumberField
      aria-label={t.scaleTicketPro.freightDetails.fields.chargeback}
      isDisabled={disabled}
      value={freightCharge.freightCost?.amount ?? 0}
      onChange={handleChange}
      prefix="$"
      formatOptions={{
        minimumFractionDigits: 2,
        maximumFractionDigits: 8,
      }}
      touchModeEnabled={touchModeEnabled}
      color="warning"
      className="@ChargebackField"
    />
  );
};
